import { useUrl } from 'crossroad';
import { flushSync } from 'react-dom';

type NavigateFunction = (path: string) => void;

/**
 * A hook that provides a navigation function that uses the View Transitions API
 * if available, falling back to a simple URL change if not.
 *
 * Note: This uses useUrl() instead of usePath() to ensure clean URLs without
 * preserving query parameters from the previous page.
 *
 * @returns A tuple containing the current path and the navigate function.
 */
export function useViewTransitionNavigate(): [string, NavigateFunction] {
    const [url, setUrl] = useUrl();

    const navigate: NavigateFunction = (newPath) => {
        if (!document.startViewTransition) {
            setUrl(newPath);
            return;
        }

        document.startViewTransition(() => {
            flushSync(() => setUrl(newPath));
        });
    };

    return [url.path, navigate];
}